import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Identification"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 3H21C21.8284 3 22.5 3.67157 22.5 4.5V19.5C22.5 20.3284 21.8284 21 21 21H3C2.17157 21 1.5 20.3284 1.5 19.5V4.5C1.5 3.67157 2.17157 3 3 3ZM21 4.5V19.5H3V4.5H21ZM15 12.75C16.6569 12.75 18 11.4069 18 9.75C18 8.09315 16.6569 6.75 15 6.75C13.3431 6.75 12 8.09315 12 9.75C12 11.4069 13.3431 12.75 15 12.75ZM4.5 7.5H9.75V9H4.5V7.5ZM4.5 10.5H7.5V12H4.5V10.5ZM17.25 13.5C18.4926 13.5 19.5 14.5074 19.5 15.75V17.25H18V15.75C18 15.3358 17.6642 15 17.25 15H12.75C12.3358 15 12 15.3358 12 15.75V17.25H10.5V15.75C10.5 14.5074 11.5074 13.5 12.75 13.5H17.25ZM16.5 9.75C16.5 8.92157 15.8284 8.25 15 8.25C14.1716 8.25 13.5 8.92157 13.5 9.75C13.5 10.5784 14.1716 11.25 15 11.25C15.8284 11.25 16.5 10.5784 16.5 9.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Identification.vue"]]);
